import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomerScreenStore {

  public readonly isCustomerScreenDisabled = signal(false);
}
